module.exports = __webpack_public_path__ + "img/hr-V-L-1-unload-connect.b2564fe7.png";